import React from 'react';

interface IconProps {
    color?: string;
    height?: string;
}

const YoutubeIcon: React.FC<IconProps> = ({ color = "#000000", height = "32" }) => (
    <svg
        height={height}
        viewBox="0 0 32 32"
        width={height}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill={color}
            d="m31.328 8.271c-.38-1.349-1.432-2.407-2.787-2.781-2.495-.667-12.525-.667-12.525-.667s-10.011-.016-12.532.667c-1.348.375-2.405 1.432-2.781 2.781-.473 2.557-.708 5.145-.697 7.745-.005 2.583.229 5.167.697 7.708.376 1.349 1.433 2.407 2.781 2.787 2.495.667 12.532.667 12.532.667s10.005 0 12.525-.667c1.355-.38 2.407-1.437 2.787-2.787.459-2.541.683-5.125.667-7.708.016-2.6-.203-5.188-.667-7.745zm-18.516 12.532v-9.595l8.349 4.808z"
        />
    </svg>
);

export default YoutubeIcon;
